import { useMemo } from 'react';
import { AircraftIcon, CarGroundIcon } from '@icons';
import { calculateRouteTimeByProviders } from '@lp/features/MultiSuggest/utils';
import { TransportType } from '@lp/features/RoutePlanner/components/TransportType';
import { AviaLegTypes, GroundLegTypes } from '@/api/apis/route';
import { GROUND_LEG_TYPES } from '@/utils/route';
import { msToFixedHours } from '@/utils/helpers';

type CurrentProviderTimeValueProps = {
  title: string;
  legs: (AviaLegTypes | GroundLegTypes)[];
};

export const CurrentProviderTimeValue = ({ title, legs }: CurrentProviderTimeValueProps) => {
  const providers = useMemo(() => {
    return calculateRouteTimeByProviders(legs);
  }, [legs]);

  const overallTimeInMs = providers.reduce((total, provider) => total + provider.timeInMs, 0);

  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-m-cps text-base-30 mr-2">{title}</span>
      {!!providers.length && (
        <>
          <div className="flex flex-wrap items-center gap-2">
            {providers.map((providerInfo) => {
              const isGround = GROUND_LEG_TYPES.includes(providerInfo.type);
              const icon = isGround ? <CarGroundIcon /> : <AircraftIcon />;

              return (
                <div key={providerInfo.type} className="flex items-center gap-1">
                  <TransportType legType={providerInfo.type} />
                  {icon}
                </div>
              );
            })}
          </div>
          <span className="text-m-sb text-black">{msToFixedHours(overallTimeInMs)}</span>
        </>
      )}
    </div>
  );
};
